import { formatDistanceToNow, format } from 'date-fns';
import { NotificationManager } from 'react-notifications';

interface saveToFileProps {
	jsonData: any
	fileName: string
}

const parseNumber = (p: number | string) => {
	return Math.abs(Math.round(Number(p) | 0));
}

const saveToFile = ({ jsonData, fileName }: saveToFileProps) => {
	// Create a Blob containing the JSON data
	const blob = new Blob([JSON.stringify(jsonData)], { type: 'application/json' });

	// Create a download link
	const downloadLink = document.createElement('a');
	downloadLink.href = window.URL.createObjectURL(blob);
	downloadLink.download = fileName + '.json';

	// Trigger the download
	document.body.appendChild(downloadLink);
	downloadLink.click();

	// Clean up
	document.body.removeChild(downloadLink);
}

const toastMessage = (type: string, html: string) => {
	switch (type) {
		case 'info': {
			NotificationManager.info(html, "Info");
			break;
		}
		case 'success': {
			NotificationManager.success(html, "Success");
			break;
		}
		case 'warning': {
			NotificationManager.warning(html, "Warning", 3000);
			break;
		}
		case 'error': {
			NotificationManager.error(html, "Error", 5000, () => { });
			break;
		}
	}
}

const textCopy = (text: string) => {
	let textField = document.createElement('textarea')
	textField.innerText = text
	document.body.appendChild(textField)
	textField.select()
	document.execCommand('copy')
	textField.remove()

	let tempText = text
	if (text.length > 12) {
		tempText = `${text.substring(0, 7)} ... `
		tempText += text.substring(text.length, text.length - 5)
	}

	toastMessage("success", "Copied: " + tempText);
}

const convertHMS = (value: number) => {
	const sec = Math.floor(value);
	let hours: number | string = Math.floor(sec / 3600); // get hours
	let minutes: number | string = Math.floor((sec - (hours * 3600)) / 60); // get minutes
	let seconds: number | string = sec - (hours * 3600) - (minutes * 60); //  get seconds

	// add 0 if value < 10; Example: 2 => 02
	if (hours < 10) { hours = `0${hours}`; }
	if (minutes < 10) { minutes = `0${minutes}`; }
	if (seconds < 10) { seconds = `0${seconds}`; }

	return `${hours}:${minutes}:${seconds}`; // Return is HH : MM : SS
}

const textEllipsis = (text: string, start: number = 5, end: number = 5) => {
	if (text.length > (start + end)) {
		return `${text.slice(0, start)}...${text.slice(-1 * end)}`
	}

	return text;
}

const capitalizeFirstLetter = (text: string) => {
	return text.charAt(0).toUpperCase() + text.slice(1)
}

const getTimeStamp = (dateTime: number) => {
	return formatDistanceToNow(dateTime * 1000, { addSuffix: true }).replace(/^about /, '')
}

const getDateTime = (dataTime: number) => {
	return format(new Date(dataTime * 1000), "yyyy-MM-dd HH:mm");
}

function delay(ms: number = 1000): Promise<void> {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export {
	parseNumber,
	saveToFile,
	toastMessage,
	textCopy,
	convertHMS,
	textEllipsis,
	capitalizeFirstLetter,
	getTimeStamp,
	getDateTime,
	delay,
}